import Particle from 'core/display/Particle'
import { signal } from 'services/SignalsService'
import { winParticles } from 'settings/custom/win'

export default class WinParticle extends Particle {
  constructor(data) {
    super(data)
    this.resize(this)
  }

  resize(object){
    signal.on('RESIZE', function ({ scale }) {
      object.scale.set( scale / 2)
    })
  }

  createSignals(emitter, data, element) {
    signal.on('WIN-ANIMATE', (type) => {
      emitter.emit = winParticles[type].includes(element)
    })

    signal.on('WIN-ANIMATE:DONE', () => {
      emitter.cleanup()
    })

    signal.on('COIN:OUT', () => {
      if(emitter.emit){
        emitter.emit = false
      }
    })
  }

}
